import { React, useState, useRef, useEffect } from "react";
import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import axiosInstance from "../../../utils/axiosInstance";
import { useNavigate } from 'react-router-dom';
import { isMobile } from "react-device-detect";

let user_role = 0;
let my_sharing = 0;
let parent_sharing = 0;
let roleArray = [];

const AddAccount = () => {
  const navigate = useNavigate();

  const [currencyShow, setCurrencyShow] = useState(false);
  const [showRoleDropdown, setShowRoleDropDown] = useState(false);
  const [userRoleArray, setRoleArray] = useState([]);
  const [selectedUserType, setselectedUserType] = useState(0);
  const [showSharingOption, setSharingOption] = useState(false);

  const [showUserNameError, setUserNameError] = useState(false);
  const [userNameErrorMessage, setUserNameErrorMessage] = useState("");

  const [showSharingError, setSharingError] = useState(false);
  const [sharingErrorMessage, setSharingErrorMessage] = useState("");

  const [showDummyBtn, setShowDummyBtn] = useState(false);

  const [showPasswordError, setPasswordError] = useState(false);
  const [showTypeError, setTypeError] = useState(false);

  const [usernameTxt, setUsernameTxt] = useState(false);
  const [showDistributorDropdown, setShowDistributorDropdown] = useState(false);
  const [distributors, setDistributors] = useState([]);
  const [selectedDistributor, setSelectedDistributor] = useState("");
  const [showDistributorError, setShowDistributorError] = useState(false);

  const getUserDetails = async () => {
    //console.log("Fetching Single event...");
    try {
      //ShowHideLoader(true);

      const response = await axiosInstance.get("/user");

      if (response.data !== null) {
        user_role = response?.data?.user_role;
        let username = response?.data?.uname;
        setUsernameTxt(username);
        if (user_role === 1) {
          setCurrencyShow(true);
        } else {
          setCurrencyShow(false);
        }

        if (user_role == 1) {
          roleArray = {
            2: "Super Company",
            3: "Company",
            4: "Superadmin",
            5: "Admin",
            6: "Super Master",
            7: "Master",
            8: "Bettor"
          };
        } else if (user_role == 2) {
          roleArray = {
            3: "Company",
            4: "Superadmin",
            5: "Admin",
            6: "Super Master",
            7: "Master",
            8: "Bettor"
          };
        } else if (user_role === 3) {
          roleArray = {
            4: "Superadmin",
            5: "Admin",
            6: "Super Master",
            7: "Master",
            8: "Bettor"
          };
        } else if (user_role === 4) {
          roleArray = {
            5: "Admin",
            6: "Super Master",
            7: "Master",
            8: "Bettor"
          };
        }
        setRoleArray(roleArray);

        if ([1, 2, 3, 4].includes(user_role)) {
          setShowRoleDropDown(true);
        } else {
          setShowRoleDropDown(false);
        }

        if ([1, 2].includes(Number(user_role))) {
          setShowDistributorDropdown(true);
          try {
            const distRes = await axiosInstance.get("/company/distributors", {
              params: { all: 1 },
            });
            setDistributors(distRes.data?.distributors || []);
          } catch (distErr) {
            console.error("Error fetching distributors:", distErr);
            setDistributors([]);
          }
        } else {
          setShowDistributorDropdown(false);
        }

        if (response.data.my_sharing !== undefined) {
          my_sharing = response.data.my_sharing;
        }
        if (response.data.parent_sharing !== undefined) {
          parent_sharing = response.data.parent_sharing;
        }
        setCanManageAutoDeposit(!!response.data?.allow_auto_deposit);
      }
      //console.log(response.data); // single event data
    } catch (error) {
      console.error("Error fetching single event:", error);
    }
  };
  useEffect(() => {
    getUserDetails();
  }, []); // Empty dependency array

  const setUserTypeInRadio = (type) => {
    let user_role = type;
    setselectedUserType(user_role);

    if (["2", "3", "4", "5", "6", "7"].includes(user_role)) {
      setSharingOption(true);
    } else {
      setSharingOption(false);
    }
  };

  const setUserTypeOnChange = (event) => {
    setselectedUserType(event.target.value);
    let user_role = event.target.value;

    if (["2", "3", "4", "5", "6", "7"].includes(user_role)) {
      setSharingOption(true);
    } else {
      setSharingOption(false);
    }
  };

  const [username, setUsername] = useState("");
  const handleUsername = (e) => {
    var username = e.target.value;
    setUsername(username);
  };

  const [password, setPassword] = useState("");
  const handlePassword = (e) => {
    var password = e.target.value;
    setPassword(password);
  };

  const [currency, setCurrency] = useState("");
  const handleCurrency = (e) => {
    var currency = e.target.value;
    setCurrency(currency);
  };

  const [downlineShare, setDownlineShare] = useState(0);
  const handleDownLineShare = (e) => {
    var downlineshare = e.target.value;
    setDownlineShare(downlineshare);
  };

  const [isActive, handleIsActive] = useState(0);
  const [allowAutoDeposit, setAllowAutoDeposit] = useState(false);
  const [canManageAutoDeposit, setCanManageAutoDeposit] = useState(false);

  const handleIsActiveCheckbox = (e) => {
    var isActive = e.target.checked;
    handleIsActive(isActive);
  };

  const handleAllowAutoDepositCheckbox = (e) => {
    setAllowAutoDeposit(e.target.checked);
  };

  const [phone, setPhone] = useState("");
  const handlePhoneNumber = (e) => {
    var phonenumber = e.target.value;
    setPhone(phonenumber);
  };

  const [reference, setReference] = useState("");
  const handleReference = (e) => {
    var reference = e.target.value;
    setReference(reference);
  };

  const [note, setNote] = useState("");
  const handleNote = (e) => {
    var note = e.target.value;
    setNote(note);
  };

  const getClipBoardText = async (username, password, role, sharing) => {
    let txtRole = "";
    if (role == 2) {
      txtRole = "SuperCompany";
    } else if (role == 3) {
      txtRole = "Company";
    } else if (role == 4) {
      txtRole = "Super Admin";
    } else if (role == 5) {
      txtRole = "Admin";
    } else if (role == 6) {
      txtRole = "SuperMaster";
    } else if (role == 7) {
      txtRole = "Master";
    } else if (role == 8) {
      txtRole = "Bettor";
    }
    let copyTxt = "Username: " + username + "\n";
    copyTxt += "Password: " + password + "\n";
    copyTxt += "Role: " + txtRole + "\n";
    copyTxt += "Role: " + txtRole + "\n";
    copyTxt += "Share: " + sharing + "\n";
    copyTxt += "URL: https://bpexch.me";

    navigator.clipboard.writeText(copyTxt);
  };

  const handleSubmit = async () => {
    var userObj = {};
    let errorCounter = 0;

    if (username === "") {
      setUserNameError(true);
      setUserNameErrorMessage("Username can not be blank");
      errorCounter++;
    } else {
      setUserNameErrorMessage("");
      setUserNameError(false);
    }

    if (password === "") {
      setPasswordError(true);
      errorCounter++;
    } else {
      setPasswordError(false);
    }

    if (selectedUserType === "") {
      setTypeError(true);
      errorCounter++;
    } else {
      setTypeError(false);
    }

    if (showDistributorDropdown && !selectedDistributor) {
      setShowDistributorError(true);
      errorCounter++;
    } else {
      setShowDistributorError(false);
    }

    setSharingErrorMessage("");
    setSharingError(false);

    if (errorCounter !== 0) {
      return;
    }

    userObj.uname = username;
    userObj.password = password;
    userObj.user_type = selectedUserType;
    userObj.downline_share = downlineShare;
    userObj.status = isActive;
    userObj.mobilenumber = phone;
    userObj.reference = reference;
    userObj.note = note;
    if (canManageAutoDeposit) {
      userObj.allow_auto_deposit = allowAutoDeposit ? 1 : 0;
    }
    if (showDistributorDropdown) {
      userObj.distributor_id = selectedDistributor;
    }

    try {
      setShowDummyBtn(true);
      const response = await axiosInstance.post("/company/user", userObj);
      if (
        response !== null &&
        response !== undefined &&
        response.data !== null &&
        response.data !== undefined
      ) {
        if (
          response.data.R !== null &&
          response.data.R !== undefined &&
          response.data.R === true
        ) {
          navigate("/agent/accounts/chart");
          getClipBoardText(username, password, selectedUserType, downlineShare);
          setShowDummyBtn(false);
        }
      }
    } catch (error) {
      setShowDummyBtn(false);
      let errorData = error.response.data;
      if (
        errorData !== null &&
        errorData !== undefined &&
        errorData.errors !== null &&
        errorData.errors !== undefined
      ) {
        let errors = errorData.errors;
        if (
          errors.username !== null &&
          errors.username != undefined &&
          errors.username !== ""
        ) {
          setUserNameError(true);
          setUserNameErrorMessage(errors.username);
        }

        if (
          errors.downline_share !== null &&
          errors.downline_share != undefined &&
          errors.downline_share !== ""
        ) {
          setSharingError(true);
          setSharingErrorMessage(errors.downline_share);
        }

        if (
          errors.distributor !== null &&
          errors.distributor != undefined &&
          errors.distributor !== ""
        ) {
          setShowDistributorError(true);
        }
      }
    }
  };

  return (
    <AgentLayout>
      <div className="bets-section-wrapper">
        <form
          action="#"
          name="addCompanyForm"
          id="addCompanyForm"
          method="post"
          style={{ padding: "9px" }}
        >
          <div className="card">
            <div className="card-header" style={{ padding: "0.25rem 1.25rem" }}>
              <strong className="site_family">
                Create New User under {usernameTxt}
              </strong>
            </div>

            <div className="card-body">
              <div
                className="text-danger validation-summary-errors"
                id="errMSg"
                style={{ display: "none" }}
              ></div>

              <div className="row" style={{ marginTop: "23px" }}>
                <div className="col-md-9">
                  <div className="form-group row">
                    <label
                      className="col-md-3 col-form-label site_family"
                      for="user_Username"
                    >
                      Username
                    </label>
                    <div className=" col-md-9">
                      <input
                        className="form-control site_family"
                        required=""
                        type="text"
                        onChange={handleUsername}
                        name="uname"
                        value={username}
                        placeholder=""
                        autocomplete="off"
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                      />
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showUserNameError ? "" : "none" }}
                      >
                        {userNameErrorMessage}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label site_family">
                      Password
                    </label>
                    <div className=" col-md-9">
                      <input
                        className="form-control site_family"
                        required=""
                        type="text"
                        onChange={handlePassword}
                        name="password"
                        value={password}
                        placeholder=""
                        autocomplete="off"
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                      />
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showPasswordError ? "" : "none" }}
                      >
                        Password can not be blank
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group row"
                    style={{ display: currencyShow ? "" : "none" }}
                    onChange={handleCurrency}
                  >
                    <label className="col-md-3 col-form-label site_family">
                      Currency
                    </label>
                    <div className=" col-md-9">
                      <select
                        name="currency"
                        value={currency}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                        className="form-control site_family"
                      >
                        <option value="2">PKR</option>
                        <option value="1">INR</option>
                        <option value="3">AED</option>
                        <option value="4">USD</option>
                      </select>
                    </div>
                  </div>

                  <div
                    className="form-group row"
                    style={{ display: showRoleDropdown ? "" : "none" }}
                  >
                    <label className="col-md-3 col-form-label site_family">
                      Type
                    </label>
                    <div className=" col-md-9">
                      <select
                        className="form-control site_family"
                        value={selectedUserType}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                        onChange={setUserTypeOnChange}
                      >
                        <option value="">--Type--</option>
                        {Object.entries(userRoleArray).map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ))}
                      </select>
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showTypeError ? "" : "none" }}
                      >
                        Please select type
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group row"
                    style={{ display: showDistributorDropdown ? "" : "none" }}
                  >
                    <label className="col-md-3 col-form-label site_family">
                      Distributor
                    </label>
                    <div className=" col-md-9">
                      <select
                        className="form-control site_family"
                        value={selectedDistributor}
                        onChange={(e) => setSelectedDistributor(e.target.value)}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                      >
                        <option value="">--Distributor--</option>
                        {distributors.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.distributor_name}
                          </option>
                        ))}
                      </select>
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showDistributorError ? "" : "none" }}
                      >
                        Please select a distributor
                      </span>
                    </div>
                  </div>

                  <div
                    className="form-group row"
                    style={{ display: !showRoleDropdown ? "" : "none" }}
                  >
                    <label className="col-md-3 col-form-label site_family">
                      Type
                    </label>
                    <div className="col-md-9 site_family">
                      <div>
                        {user_role === 5 && (
                          <p>
                            <input
                              type="radio"
                              name="user_type"
                              value="6"
                              onClick={() => setUserTypeInRadio("6")}
                            />{" "}
                            <span className="site_family">Super Master</span>
                            <input
                              type="radio"
                              name="user_type"
                              value="8"
                              onClick={() => setUserTypeInRadio("8")}
                            />{" "}
                            <span className="site_family">Bettor</span>
                          </p>
                        )}

                        {user_role === 6 && (
                          <p>
                            <input
                              type="radio"
                              name="user_type"
                              value="7"
                              onClick={() => setUserTypeInRadio("7")}
                            />{" "}
                            <span className="site_family">Master</span>
                            <input
                              type="radio"
                              name="user_type"
                              value="8"
                              onClick={() => setUserTypeInRadio("8")}
                            />{" "}
                            <span className="site_family">Bettor</span>
                          </p>
                        )}

                        {user_role === 7 && (
                          <p>
                            <input
                              type="radio"
                              name="user_type"
                              value="8"
                              onClick={() => setUserTypeInRadio("8")}
                            />{" "}
                            <span className="site_family">Bettor</span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="form-group row"
                    style={{ display: showSharingOption ? "" : "none" }}
                  >
                    <label className="col-md-3 col-form-label site_family">
                      Downline Share
                    </label>
                    <div className=" col-md-9">
                      <input
                        type="number"
                        value={downlineShare}
                        placeholder="0"
                        onChange={handleDownLineShare}
                        name="downline_share"
                        className="form-control textbox_width site_family"
                        autocomplete="off"
                        min="0"
                        max={my_sharing}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "40%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                      />
                      <span className="site_family">
                        Max allowed downline share is 0 -{my_sharing}
                      </span>
                      <br></br>
                      <span
                        className="field-validation-error site_family"
                        style={{ display: showSharingError ? "" : "none" }}
                      >
                        {sharingErrorMessage}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label site_family">
                      IsActive
                    </label>
                    <div className=" col-md-9">
                      <input
                        className="form-control textbox_width site_family"
                        style={{ width: "15px", height: "15px" }}
                        type="checkbox"
                        checked={isActive}
                        onChange={handleIsActiveCheckbox}
                        name="status"
                        value="true"
                      />
                    </div>
                  </div>

                  {canManageAutoDeposit && (
                    <div className="form-group row">
                      <label className="col-md-3 col-form-label site_family">
                        Allow Auto Deposit
                      </label>
                      <div className=" col-md-9">
                        <input
                          className="form-control textbox_width site_family"
                          style={{ width: "15px", height: "15px" }}
                          type="checkbox"
                          checked={allowAutoDeposit}
                          onChange={handleAllowAutoDepositCheckbox}
                          name="allow_auto_deposit"
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label  site_family">
                      Phone
                    </label>
                    <div className=" col-md-9">
                      <input
                        max={my_sharing}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                        type="text"
                        placeholder=""
                        value={phone}
                        onChange={handlePhoneNumber}
                        name="mobilenumber"
                        className="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label site_family">
                      Reference
                    </label>
                    <div className=" col-md-9">
                      <input
                        max={my_sharing}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 2px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                        type="text"
                        placeholder=""
                        value={reference}
                        onChange={handleReference}
                        name="reference"
                        className="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label site_family">
                      Notes
                    </label>
                    <div className=" col-md-9">
                      <textarea
                        max={my_sharing}
                        style={{
                          display: "block",
                          fontSize: "1rem",
                          width: "100%",
                          height: "calc(2.0625rem + 50px)",
                          padding: "0.375rem 0.75rem",
                          lineHeight: "1.5",
                          color: "#5c6873",
                          backgroundColor: "#fff",
                          backgroundClip: "padding-box",
                          border: "1px solid #e4e7ea",
                          borderRadius: "0.25rem",
                          transition:
                            "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
                        }}
                        className="form-control"
                        onChange={handleNote}
                        name="note"
                      >
                        {note}
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer" style={{ float: "right" }}>
              <button
                className="btn btn-sm btn-primary site_family"
                style={{
                  display: showDummyBtn ? "none" : "",
                  float: isMobile ? "right" : "left"
                }}
                onClick={handleSubmit}
                type="button"
              >
                Submit
              </button>

              <button
                className="btn btn-sm btn-gray site_family"
                style={{
                  backgroundColor: "#7c7c7c",
                  color: "white",
                  float: isMobile ? "right" : "left",
                  display: showDummyBtn ? "" : "none"
                }}
                type="button"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </AgentLayout>
  );
};
export default AddAccount;